export default __webpack_public_path__ + "static/media/index.d7cf525b.less";